import React from "react";
import "./Counter.scss";

interface IProps {
    value: number
    minDigits?: number
}

export function Counter({
    value,
    minDigits = 0
                        }: IProps) {
    let stringValue = value.toString();
    while(stringValue.length < minDigits) stringValue = `0${stringValue}`;

    return (
        <div className="counter-wrapper">
            {stringValue}
        </div>
    )
}
